module.exports = __webpack_public_path__ + "img/icon-close.6122012b.svg";